/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown> }} Coaching_Pdf_WeightInputs */

const en_us2_coaching_pdf_weight = /** @type {(inputs: Coaching_Pdf_WeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weight: from ${i?.first} to ${i?.last}`)
};

const pt_br2_coaching_pdf_weight = /** @type {(inputs: Coaching_Pdf_WeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso: de ${i?.first} para ${i?.last}`)
};

const pt_pt2_coaching_pdf_weight = /** @type {(inputs: Coaching_Pdf_WeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso: de ${i?.first} para ${i?.last}`)
};

/** @type {(inputs: Coaching_Pdf_WeightInputs) => LocalizedString} */
const es_419_coaching_pdf_weight = en_us2_coaching_pdf_weight;

/** @type {(inputs: Coaching_Pdf_WeightInputs) => LocalizedString} */
const fr_fr2_coaching_pdf_weight = en_us2_coaching_pdf_weight;

/** @type {(inputs: Coaching_Pdf_WeightInputs) => LocalizedString} */
const de_de2_coaching_pdf_weight = en_us2_coaching_pdf_weight;

/** @type {(inputs: Coaching_Pdf_WeightInputs) => LocalizedString} */
const it_it2_coaching_pdf_weight = en_us2_coaching_pdf_weight;

/**
* | output |
* | --- |
* | "Weight: from {first} to {last}" |
*
* @param {Coaching_Pdf_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_pdf_weight = /** @type {((inputs: Coaching_Pdf_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Pdf_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_pdf_weight(inputs)
	if (locale === "es-419") return es_419_coaching_pdf_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_pdf_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_pdf_weight(inputs)
	if (locale === "de-DE") return de_de2_coaching_pdf_weight(inputs)
	if (locale === "it-IT") return it_it2_coaching_pdf_weight(inputs)
	return en_us2_coaching_pdf_weight(inputs)
});
export { coaching_pdf_weight as "coaching.pdf_weight" }